import React from 'react'
import { isInstitutional } from '../../../../../global/authentication/authentication-manager.js'
import InstitutionalBlogArticleCard from './InstitutionalBlogArticleCard.jsx'
import AdvisorBlogArticleCard from './AdvisorBlogArticleCard.jsx'

function BlogArticleCard({ item, taxonomies, children }) {
  if (isInstitutional()) {
    return (
      <InstitutionalBlogArticleCard item={item} taxonomies={taxonomies}>
        {children}
      </InstitutionalBlogArticleCard>
    )
  }

  return <AdvisorBlogArticleCard item={item}>{children}</AdvisorBlogArticleCard>
}

export default BlogArticleCard
